import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	TABLET_BP,
	TABLET_M_BP,
	MOBILE_L_BP,
	COLOR_TEXT_HIGHLIGHT,
} from "@website-builder/utilities-index";

export const ImageContainer = styled.div`
	text-align: center;
	padding: 85px 50px 100px 50px;
	.slick-slider {
		.slick-next:before,
		.slick-prev:before {
			font-size: 36px !important;
			color: ${COLOR_TEXT_HIGHLIGHT};
		}
		.slick-prev {
			left: -40px;
		}
	}
	.heading {
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		line-height: 1;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding-bottom: 60px;
	}
	div {
		width: unset;
	}
	.slick-slide {
		div {
			text-align: center;
			div {
				width: unset !important;
				img {
					width: 400px;
					border-radius: 3px;
				}
			}
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) and (min-width: ${TABLET_BP +
		1}px) {
		padding: 45px 65px 70px 65px;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) and (min-width: ${MOBILE_L_BP +
		1}px) {
		padding: 45px 65px 70px 65px;
		.slick-slide {
			div {
				div {
					width: unset !important;
					img {
						width: 311px;
					}
				}
			}
		}
		.heading {
			font-size: 26px;
			line-height: 1.08;
			padding-bottom: 30px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 40px 55px 75px 55px;
		.slick-slide {
			div {
				div {
					width: unset !important;
					img {
						width: 255px;
					}
				}
			}
		}
		.heading {
			font-size: 24px;
			line-height: 1.25;
			padding-bottom: 30px;
		}
	}
`;
